import { AssistantIncidentSeverityEnum, AssistantRecommendedActionEnum } from '../../enums';

export interface AssistantRecommendedStationDto {
  id: string;
  name: string;
  category: string;
  lat: number;
  lng: number;
  address: string;
  city: string;
  state: string;
  phone?: string;
  website?: string;
  distance_km: number;
}

export interface AssistantReportTurnDto {
  question: string;
  title: string;
  body: string;
  causes: string[];
  incidentSeverity?: AssistantIncidentSeverityEnum;
  recommendedAction?: AssistantRecommendedActionEnum;
  recommendedStations?: AssistantRecommendedStationDto[];
}

export interface AssistantReportValueDto {
  label: string;
  value: number;
  unit: string;
  ageSeconds: number;
  staleAtCapture: boolean;
  origin: string;
  sourceAddress: number | null;
}

export interface AssistantReportFaultCodeDto {
  code: string;
  status: number;
  label: string;
  description: string;
  occurrences: number | null;
}

export interface AssistantReportFaultDto {
  origin: string;
  ageSeconds: number;
  staleAtCapture: boolean;
  codes: AssistantReportFaultCodeDto[];
  sourceAddress: number | null;
}

export interface AssistantReportDto {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  schemaVersion: number;
  companyId: string;
  title: string;
  capturedAt: number;
  capturedLabel: string;
  simulated: boolean;
  origin: string;
  vehicleModel?: string;
  vin?: string;
  profile: string;
  adapterVersion: string;
  adapterVoltage: number;
  turns: AssistantReportTurnDto[];
  additionalInput?: string;
  notes?: string;
  ecuCapturedLabel: string;
  broadcastFrames: number;
  values: AssistantReportValueDto[];
  faults: AssistantReportFaultDto[];
  incidentSeverity?: AssistantIncidentSeverityEnum;
  recommendedAction?: AssistantRecommendedActionEnum;
}
